import axios from 'axios';
import { URLS } from '@constants/urls';
import api from '@helpers/api';

export const getConstituencyWiseResults = (() => {
  const cancelToken = axios.CancelToken;
  let source = cancelToken.source();
  let isRequestInProcess = false;

  return async (query: {
    division: string;
    timeSlot: string;
    percentage: number | string;
    election_schedule_id: string;
  }): Promise<{ data: any }> => {
    if (isRequestInProcess) {
      source.cancel();
      source = cancelToken.source();
    }

    isRequestInProcess = true;
    return api
      .get(URLS.GET_CONSTITUENCY_WISE_RESULTS(query))
      .then((response) => {
        return { data: response.data };
      })
      .finally(() => {
        isRequestInProcess = false;
      });
  };
})();
